var _Path, _Path2, _Path3, _Path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgImage(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.333 13.333a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M17.666 2.663h-5.333C5.666 2.663 3 5.33 3 11.996v8c0 6.667 2.666 9.334 9.333 9.334h8c6.667 0 9.333-2.667 9.333-9.334V13.33",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M21.333 6.663h7.334M25 10.333V3",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M3.893 25.266l6.574-4.413c1.053-.707 2.573-.627 3.52.186l.44.387c1.04.893 2.72.893 3.76 0l5.546-4.76c1.04-.893 2.72-.893 3.76 0l2.174 1.866",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgImage;